<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 380px;
  height: 200px;
  padding: 18px 0;
}

.instruction {
  display: flex;
  justify-content: space-between;

  .item-name {
    margin-bottom: 5px;
    color: #77CAD8;
    font-size: 14px;
  }

  .item-num {
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
  }
}

.twoBars {
  width: 420px;
  height: 200px;
  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
    <div class="bar-wrap">
      <div class="twoBars">
        <div class="main"></div>
      </div>
    </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {}
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.twoBars .main'));
    this.myChart.setOption({
      // backgroundColor: '#00265f',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['采购总额', '帮扶金额'],
        align: 'right',
        right: 10,
        textStyle: {
          color: "#fff"
        },
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 35
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [{
        type: 'category',
        data: ['芒果', '沃柑', '圣女果', '牛心李', '火龙果', '百香果', '番茄'],
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          interval: 0,
          textStyle: {
            color: "#00c7ff",
            fontSize: 12
          }
        }
      }],
      yAxis: [{
        type: 'value',
        axisLabel: {
          formatter: '{value}'
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#063374"
          }
        }
      }],
      series: [{
        name: '采购总额',
        type: 'bar',
        data: [235304, 93584, 56823, 48398, 39875, 33415, 25436],
        barWidth: 5, // 柱子宽度
        barGap: 1, // 柱子之间间距
        itemStyle: {
          normal: {
            color: '#FF9E2C',
            barBorderRadius: 4,
            opacity: 1
          }
        }
      }, {
        name: '帮扶金额',
        type: 'bar',
        data: [135264, 54263, 25563, 28535, 27424, 16437, 12473],
        barWidth: 5,
        barGap: 1,
        itemStyle: {
          normal: {
            color: '#31C2E2',
            barBorderRadius: 4,
            opacity: 1
          }
        }
      }]
    })
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?7ef1e2e0